import React, { useRef, useEffect } from 'react';
import Slider from "react-slick";
import { AppContext } from '../App';
import { useContext } from 'react';
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import { IoMdAnalytics, IoMdBriefcase, IoMdCheckmarkCircleOutline, IoMdClipboard, IoMdCloudOutline, IoMdCodeWorking, IoMdFolder, IoMdGitNetwork, IoMdLaptop, IoMdPie, IoMdSchool, IoMdSearch, IoMdStats } from 'react-icons/io';

export default function HomeSlider() {
	const sliderRef = useRef(null);
	const appContext = useContext(AppContext);

	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];


	useEffect(() => {
		const slider = sliderRef.current;

		const preventTouchEvents = (e) => {
			e.stopPropagation(); // Prevent the event from reaching the parent
		};

		if (slider) {
			// Attach event listeners to prevent touch events from propagating to parent
			slider.addEventListener('touchstart', preventTouchEvents);
			slider.addEventListener('touchmove', preventTouchEvents);
			slider.addEventListener('touchend', preventTouchEvents);
		}

		return () => {
			if (slider) {
				// Clean up the event listeners when the component is unmounted
				slider.removeEventListener('touchstart', preventTouchEvents);
				slider.removeEventListener('touchmove', preventTouchEvents);
				slider.removeEventListener('touchend', preventTouchEvents);
			}
		};
	}, []);

	const settings = {
		dots: false,
		infinite: true,
		speed: 800,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		arrows: false,
		pauseOnHover: false,   // 👈 keep autoplay running when hovering
  	pauseOnFocus: false,   // 👈 keep autoplay running when focused
	};

	return (
		<div className='WelcomeSlider' ref={sliderRef}>
			<Slider {...settings}>
				
				<div
					style={{
						width: "100%",
						height: "auto",
						overflow: "hidden",
						
					}}
				>
					<div
						style={{
							width: "100vw",
							height: "calc(100vh - var(--topBarHeight))",
							background: "rgba(0, 0, 0, 0.5)",
							position: "relative",
							zIndex: 1,
							backgroundImage: `url(${banner3})`,
							backgroundAttachment: "fixed",
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					>

					
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "rgba(0,0,0,0.5)",
							}}
						>
							<div className="container">
								<div className="row">
									
									<div className="col-md-12 text-center intro-text">
										<h1
											className="font-light text-light"
											style={{
												fontSize: "32px",
												paddingTop: "120px",
												paddingBottom: "10px",
											}}
										>
											Reliable & Innovative ICT solutions.
										</h1>

										<h1
											className="font-bold text-light intro-text"
											style={{
												paddingTop: "20px",
											}}
										>
											Premium Systems Company
										</h1>


										<div 
											className="text-center"
											style={{
												paddingTop: "60px"
											}}
										>
											

											<button
												className="btn btn-padded btn-primary"
												style={{
													marginTop: "10px",
													
												}}
												onClick={() => {
													appContext.navTo({
														item: 'contact_us'
													})
												}}
											>
												Consult Boston Unique Services
											</button>
										</div>

									</div>

									

								</div>
							</div>
						</div>
						
					</div>
				</div>

				<div
					style={{
						width: "100%",
						height: "auto",
						overflow: "hidden",
						
					}}
				>
					<div
						style={{
							width: "100vw",
							height: "calc(100vh - var(--topBarHeight))",
							background: "rgba(0, 0, 0, 0.7)",
							position: "relative",
							zIndex: 1,
							backgroundImage: `url(${banner1})`,
							backgroundAttachment: "fixed",
							backgroundSize: "cover",
							backgroundPosition: "center",
							overflow: "auto"
						}}
					>

					
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "rgba(0, 0, 0, 0.7)",
							}}
						>

						<div className="container">

							<div className="row" >

						<div 
							className="col-md-12 mt-3"
						>
							
							<div
								style={{
									padding: "20px",
									marginBottom: "30px",
									background: "rgba(255, 255, 255, 0.3)",
									borderRadius: "10px"
								}}

								className=""
							>
								<h2
									className="font-bold text-primary mb-3"
								>
									Expertise
								</h2>

								<div className="row d-flex justify-content-center">
									
									<div className="col-md-12 rounded bg-secondary d-flex flex-column justify-content-evenly p-3 text-center">
										<div>
											<div className="font-bold mb-2">
												<h1>15+</h1>
											</div>
											<h6>
												Years Of Experience
											</h6>
										</div>
										
										<hr />
										<h6 class="fw-bold mb-3 text-center">Our Offers Cover the Following Major Areas:</h6>
										<div class="row">
											<div class="col-md-6">
											<ul class="list-unstyled mb-0 text-start">
												<li>• System Analysis & Business Process Reengineering</li>
												<li>• Customized Software & Application Development</li>
												<li>• Network Design, Monitoring & Security Management</li>
											</ul>
											</div>
											<div class="col-md-6">
											<ul class="list-unstyled mb-0 text-start">
												<li>• Automation & Integration for Enterprises</li>
												<li>• Project Management & Technical Support</li>
												<li>• Web, E-Business & Cloud-Based Solutions</li>
											</ul>
											</div>
										</div>

										
									</div>
								</div>
								
							</div>

						</div>

						
					</div>


						</div>

						</div>
						
					</div>
				</div>

			</Slider>
		</div>
	);
}
